import React, { useEffect, useState } from 'react';
import SaveProjectModal from '../../Home/OrderSummery/SaveProjectModal';
import AccessLinkPage from '../../Home/OrderSummery/AccessLinkPage';

// Footer component for the cart page.
// Manages the state and flow for saving a project and displaying the access link modal.
const CartFooter = () => {
  // State to control the visibility of the first modal (SaveProjectModal)
  const [showSaveModal, setShowSaveModal] = useState(false);
  // State to control the visibility of the second modal (AccessLinkPage)
  const [showAccessModal, setShowAccessModal] = useState(false);

  // States to store the data received from the first modal
  const [uniqueCode, setUniqueCode] = useState<string | null>(null);
  const [productSummary, setProductSummary] = useState<any>(null); // Consider a more specific type if possible


  const handleCloseAccessModal = () => {
    setShowSaveModal(false)
    setProductSummary(null)
    setUniqueCode('')
    setShowAccessModal(false)
  }

  // Effect to transition from the save modal to the access link modal.
  // This runs when the save modal is hidden and both uniqueCode and productSummary are set.
  useEffect(() => {
    // Check if the save modal was just closed AND we have the necessary data
    if (!showSaveModal && uniqueCode && productSummary) {
      setShowAccessModal(true); // Show the second modal
    }

  }, [showSaveModal, uniqueCode, productSummary, showAccessModal]); // Dependencies for the effect

  return (
    <>
      {/* Finalize Selection button container */}
      <div className="flex justify-end items-center mt-8 sm:px-0">
        {/* Button to open the Save Project Modal */}
        <button
          onClick={() => setShowSaveModal(true)}
          className="w-full sm:w-auto bg-black text-white px-8 py-3 rounded hover:bg-gray-800 transition-colors"
        >
          Finalize Selection
        </button>
      </div>

      {/* Render Save Project Modal if showSaveModal is true */}
      {showSaveModal && (
        <SaveProjectModal
          show={showSaveModal} // Pass visibility state
          onHide={() => setShowSaveModal(false)} // Pass function to close this modal
          setUniqueCode={setUniqueCode} // Pass setter to update uniqueCode state in parent
          setProductSummary={setProductSummary} // Pass setter to update productSummary state in parent
        />
      )}

      {/* Render Access Link Page Modal if showAccessModal is true */}
      {showAccessModal && (
        <AccessLinkPage
          show={showAccessModal} // Pass visibility state
          onHide={() => handleCloseAccessModal()} // Pass function to close this modal
          uniqueCode={uniqueCode} // Pass unique code data
          productSummary={productSummary} // Pass product summary data
        />
      )}
    </>
  );
};

export default CartFooter; 